// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.message-bar[data-v-a1c0dccc] {\n  position: fixed;\n  top: 0;\n  left: 50%;\n  width: 50%;\n  min-height: 50px;\n  z-index: 9999;\n  margin-left: -25%;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
